var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgApple(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.571,
    height: 18.274,
    viewBox: "0 0 15.571 18.274",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "apple",
    d: "M15.143,6.384a2.754,2.754,0,0,0-1.5,1.394,4.473,4.473,0,0,0-.6,2.166,4.688,4.688,0,0,0,.686,2.467,2.993,2.993,0,0,0,1.844,1.437,9.226,9.226,0,0,1-1.137,2.381,6.9,6.9,0,0,1-1.608,1.823,2.958,2.958,0,0,1-1.716.472,4.545,4.545,0,0,1-1.587-.343,3.083,3.083,0,0,0-1.33-.386,6.068,6.068,0,0,0-1.716.515,4.785,4.785,0,0,1-1.115.215,3.388,3.388,0,0,1-2.1-.858,10.228,10.228,0,0,1-2.4-3.475A10.634,10.634,0,0,1,0,9.988,6.486,6.486,0,0,1,1.309,5.977,4,4,0,0,1,4.633,4.239a4.537,4.537,0,0,1,2.059.472,2.667,2.667,0,0,0,1.458.472,3.549,3.549,0,0,0,1.33-.257,7.74,7.74,0,0,1,2.23-.686,3.822,3.822,0,0,1,2.617.987,4.048,4.048,0,0,1,.815,1.158ZM7.679,4.368a4.286,4.286,0,0,1,1.072-2.7A4.479,4.479,0,0,1,11.367.25a4.375,4.375,0,0,1-1.03,2.874,3.543,3.543,0,0,1-2.66,1.244Z",
    transform: "translate(0 -0.25)",
    opacity: 0.3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApple);
export default __webpack_public_path__ + "static/media/apple.cbc40efe5b6937acf6febe4ec000170f.svg";
export { ForwardRef as ReactComponent };